import { DealsEnum } from '@b-stock/search-api-client'

/**
 * True when a listing's deal value is the top FMV-recovery tier ("Great Price").
 * This is the only tier that renders the single "Hot Deal" badge; the two lower
 * tiers ("Good Price", "Fair Price") render no badge. Single source of truth for
 * the deal-badge render and analytics gating.
 */
export const isTopTierDeal = (deal: string | null | undefined): boolean =>
  deal === DealsEnum.GreatPrice
